import { render } from "./IconClose.vue?vue&type=template&id=487760d1&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconClose.vue?vue&type=script&lang=js"
export * from "./IconClose.vue?vue&type=script&lang=js"
script.render = render

export default script